var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 66,
    viewBox: "0 0 47 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.621 13.5265C17.5481 14.6837 18.4139 15.6871 19.5549 15.7599C20.704 15.8327 21.7074 14.975 21.7883 13.8259C21.8692 12.6768 21.0035 11.6734 19.8544 11.5925C18.7053 11.5116 17.7019 12.3774 17.621 13.5265Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6464 13.3889C15.5008 15.6385 17.1921 17.5887 19.4175 17.7344C21.659 17.88 23.609 16.205 23.7628 13.9635C23.9246 11.722 22.2335 9.77179 19.992 9.61804C17.7505 9.4562 15.7921 11.1474 15.6464 13.3889Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7087 9.61804V10.6134",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6387 13.656H16.5206",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8972 13.656H23.7467",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8523 10.7995L17.4914 11.4388",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.926 11.4388L22.5653 10.7995",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0569 13.656L18.22 12.2479",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2497 57.523H15.1205C7.3279 57.523 1.00806 51.2031 1.00806 43.4104V15.1125C1.00806 7.31989 7.3279 1 15.1205 1H23.7952C31.5878 1 37.9077 7.31989 37.9077 15.1125V41.6868",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.1008H37.9077",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7088 36.864C26.0192 36.864 31.1349 35.1322 31.1349 32.996C31.1349 30.8597 26.0192 29.128 19.7088 29.128C13.3984 29.128 8.28296 30.8597 8.28296 32.996C8.28296 35.1322 13.3984 36.864 19.7088 36.864Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1551 31.7822H14.3762V34.2098H18.1551V31.7822Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0414 31.7822H21.2625V34.2098H25.0414V31.7822Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6519 32.996H28.2865",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.188 32.996H12.8224",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6015 65C41.4873 65 46.2587 60.2286 46.2587 54.3428C46.2587 48.4569 41.4873 43.6855 35.6015 43.6855C29.7157 43.6855 24.9443 48.4569 24.9443 54.3428C24.9443 60.2286 29.7157 65 35.6015 65Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6906 53.4769L37.6409 46.0808L31.3777 55.33H35.1323L33.1822 62.7261L39.3563 53.4769H35.6906Z",
    stroke: "#322D60",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricHeating);
export default __webpack_public_path__ + "static/media/electricHeating.730c0606a6c041ba3429e8f45c2ee877.svg";
export { ForwardRef as ReactComponent };